import React from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const EliminarPropuesta = (props) => {
  const propuesta = props.propuesta;

  const eliminarPropuesta = () => {
    Swal.mixin({
      input: "text",
      confirmButtonText: "Eliminar",
      showCancelButton: true,
    })
      .queue([
        {
          title: "¿Estás seguro que deseas eliminar esta propuesta?",
          text: "Escriba la razón por la que se elimina la misma.",
        },
      ])
      .then((result) => {
        if (result.value) {
          const observaciones = propuesta.observaciones;
          const observacion = {
            mensaje: result.value[0],
            fecha: new Date().toLocaleDateString(),
          };
          observaciones.unshift(observacion);
          try {
            axios
              .put(`/api/propuestas/${propuesta._id}`, {
                estado: "borrada",
                observaciones: observaciones,
              })
              .then(() => {
                Swal.fire("Se elimino la propuesta con exito", "", "success");
                props.history.push("/consola");
              })
              .catch((err) => {
                Swal.fire(err, "", "error");
                props.history.push("/consola");
              });
          } catch (error) {
            Swal.fire(error, "", "error");
          }
        }
      });
  };

  if (!propuesta) return null;

  return (
    <div className="col-md-12 text-right">
      <button
        className="btn ppr-btn-rojo font-weight-bold btn-sm my-2"
        onClick={eliminarPropuesta}
      >
        Eliminar Propuesta
      </button>
    </div>
  );
};

export default withRouter(EliminarPropuesta);
